import { BrightcoveVideo } from "@blocks/BrightcoveVideo/BrightcoveVideo";
import { BC_PLAYER_ID } from "@helper/getEnvVariables";
import { isClientSide } from "@helper/utils";
import { useEffect, useRef, useState } from "react";
import { twMerge } from "tailwind-merge";

export type PodcastDialogProps = {
  videoDialog: {
    visible: boolean;
    source: string;
  };
  handleOnClickCloseDialog: () => void;
  playerId?: string;
};

export default function VideoDialog({
  videoDialog,
  handleOnClickCloseDialog,
  playerId = BC_PLAYER_ID,
}: PodcastDialogProps) {
  const { visible, source } = videoDialog;

  // Check word quiz popup is present.
  const [wordQuizAvailable, setWordQuizAvailable] = useState(false);
  const [wordQuizExpanded, setWordQuizExpanded] = useState(false);
  const targetRef = useRef<Element | null>(null);

  useEffect(() => {
    if (!isClientSide && visible) return;

    const wordQuizWrapperCheck = () => {
      const wordQuizHtmlData = document.querySelector(
        "#word-puzzle button.collapse-button div",
      );
      if (!wordQuizHtmlData) {
        setTimeout(wordQuizWrapperCheck, 300);
        return;
      }
      setWordQuizAvailable(true);
      targetRef.current = wordQuizHtmlData;

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const classList = (mutation.target as HTMLElement).classList;
            setWordQuizExpanded(classList.contains("invisible"));
          }
        });
      });

      observer.observe(wordQuizHtmlData, {
        attributes: true,
        attributeFilter: ["class"],
      });

      return () => {
        observer.disconnect();
      };
    };

    wordQuizWrapperCheck();
  }, [visible]);

  return (
    <>
      {visible && (
        <div
          className={twMerge(
            "fixed right-1 lg:right-4 lg:p-2 z-50 w-full lg:w-[520px]",
            wordQuizAvailable ? "bottom-20" : "bottom-4",
            wordQuizAvailable && wordQuizExpanded && "bottom-5xl",
          )}
        >
          <div className="relative">
            <BrightcoveVideo videoId={source} playerId={playerId} />
          </div>
          <div className="z-10 absolute top-4 right-4 lg:right-2.5 flex items-center justify-center w-8 h-8 p-1 rounded-full bg-black-500">
            <button
              onClick={handleOnClickCloseDialog}
              id="close"
              className="text-white-100 text-sm outline-none focus:outline-none"
            >
              X
            </button>
          </div>
        </div>
      )}
    </>
  );
}
